/* ============================================================
   financing-page.js  — TrailerSwap Financing Page
   Handles: smooth scroll · modal open/close/focus-trap ·
            phone/zip formatters · calculator · form submit
   ============================================================ */
(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     UTILITIES
  ────────────────────────────────────────────────────────── */

  /** Strip everything that isn't a digit or decimal point */
  function rawNum(str) {
    return parseFloat(String(str).replace(/[^0-9.]/g, '')) || 0;
  }

  /** Format a number as a USD currency string: 12345.6 → "$12,345.60" */
  function fmtCurrency(n) {
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /** Format integer (no decimals): 12345 → "$12,345" */
  function fmtCurrencyInt(n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  }

  /** Format a plain number with commas (for input display): 12345 → "12,345" */
  function fmtCommas(n) {
    return Math.round(n).toLocaleString('en-US');
  }

  /* ──────────────────────────────────────────────────────────
     SMOOTH SCROLL
  ────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ──────────────────────────────────────────────────────────
     MODAL — open / close / focus trap / Escape
  ────────────────────────────────────────────────────────── */
  var backdrop   = document.getElementById('ts-modal');
  var modalCard  = document.getElementById('ts-modal-card');
  var formView   = document.getElementById('ts-form-view');
  var successView= document.getElementById('ts-success-view');
  var form       = document.getElementById('ts-form');
  var formErrBox = document.getElementById('ts-form-err');
  var submitBtn  = document.getElementById('ts-submit');
  var lastFocused;

  function focusableEls() {
    return Array.from(
      modalCard.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) { return el.offsetParent !== null; });
  }

  function openModal() {
    lastFocused = document.activeElement;
    /* Measure scrollbar width before hiding it, then pad the body by that
       amount so content doesn't shift when the scrollbar disappears. */
    var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarW > 0) {
      document.body.style.paddingRight = scrollbarW + 'px';
    }
    document.documentElement.style.overflow = 'hidden';
    backdrop.style.display = 'flex';
    requestAnimationFrame(function () {
      backdrop.classList.add('open');
    });
    var first = focusableEls()[0];
    if (first) setTimeout(function () { first.focus(); }, 60);
  }

  function closeModal() {
    backdrop.classList.remove('open');
    document.documentElement.style.overflow = '';
    document.body.style.paddingRight = '';
    setTimeout(function () {
      backdrop.style.display = 'none';
      resetForm();
    }, 250);
    if (lastFocused) lastFocused.focus();
  }

  function resetForm() {
    if (!form) return;
    form.reset();
    clearErrors();
    if (formView)    formView.style.display = '';
    if (successView) successView.style.display = 'none';
    if (submitBtn) {
      submitBtn.classList.remove('loading');
      submitBtn.disabled = false;
    }
    if (formErrBox) formErrBox.textContent = '';
  }

  /* Open triggers */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.ts-open-modal')) openModal();
  });

  /* Close triggers */
  document.addEventListener('click', function (e) {
    if (!backdrop) return;
    if (e.target.closest('.ts-modal-close')) { closeModal(); return; }
    if (e.target === backdrop) closeModal();
  });

  /* Escape key */
  document.addEventListener('keydown', function (e) {
    if (!backdrop) return;
    if (e.key === 'Escape' && backdrop.classList.contains('open')) closeModal();
    /* Focus trap */
    if (e.key === 'Tab' && backdrop.classList.contains('open')) {
      var els = focusableEls();
      if (!els.length) { e.preventDefault(); return; }
      var first = els[0];
      var last  = els[els.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    }
  });

  /* ──────────────────────────────────────────────────────────
     PHONE FORMATTER  →  (555) 000-0000
  ────────────────────────────────────────────────────────── */
  var phoneInput = form && form.querySelector('input[name="phone"]');
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      var digits = this.value.replace(/\D/g, '').slice(0, 10);
      var out = '';
      if (digits.length > 0) out += '(' + digits.slice(0, 3);
      if (digits.length >= 4) out += ') ' + digits.slice(3, 6);
      if (digits.length >= 7) out += '-' + digits.slice(6, 10);
      this.value = out;
    });
  }

  /* ──────────────────────────────────────────────────────────
     ZIP FORMATTER  →  digits only, max 5
  ────────────────────────────────────────────────────────── */
  var zipInput = form && form.querySelector('input[name="zip"]');
  if (zipInput) {
    zipInput.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 5);
    });
  }

  /* ── SENSITIVE FIELD FORMATTERS ──────────────────────────────────────── */
  var ssnInput = form && form.querySelector('input[name="ssn"]');
  if (ssnInput) {
    ssnInput.addEventListener('input', function () {
      var d = this.value.replace(/\D/g, '').slice(0, 9);
      var out = d.slice(0, 3);
      if (d.length > 3) out += '-' + d.slice(3, 5);
      if (d.length > 5) out += '-' + d.slice(5, 9);
      this.value = out;
    });
  }

  var dobInput = form && form.querySelector('input[name="dob"]');
  if (dobInput) {
    dobInput.addEventListener('input', function () {
      var d = this.value.replace(/\D/g, '').slice(0, 8);
      var out = d.slice(0, 2);
      if (d.length > 2) out += ' / ' + d.slice(2, 4);
      if (d.length > 4) out += ' / ' + d.slice(4, 8);
      this.value = out;
    });
  }
  /* ── END SENSITIVE FIELD FORMATTERS ──────────────────────────────────── */

  /* ──────────────────────────────────────────────────────────
     FORM VALIDATION
  ────────────────────────────────────────────────────────── */
  function clearErrors() {
    if (!form) return;
    form.querySelectorAll('.mf.error').forEach(function (el) {
      el.classList.remove('error');
    });
  }

  function setError(fieldWrapper) {
    if (fieldWrapper) fieldWrapper.classList.add('error');
  }

  function validateForm() {
    clearErrors();
    var ok = true;
    var firstNameWrap = document.getElementById('f-firstName');
    var emailWrap     = document.getElementById('f-email');
    var phoneWrap     = document.getElementById('f-phone');

    var firstName = form.querySelector('input[name="firstName"]');
    var email     = form.querySelector('input[name="email"]');
    var phone     = form.querySelector('input[name="phone"]');

    if (!firstName || !firstName.value.trim()) { setError(firstNameWrap); ok = false; }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) { setError(emailWrap); ok = false; }
    if (!phone || phone.value.replace(/\D/g, '').length < 10) { setError(phoneWrap); ok = false; }

    return ok;
  }

  /* ──────────────────────────────────────────────────────────
     FORM SUBMISSION
  ────────────────────────────────────────────────────────── */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateForm()) return;

      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      if (formErrBox) formErrBox.textContent = '';

      var payload = {
        firstName:     (form.querySelector('[name="firstName"]') || {}).value || '',
        lastName:      (form.querySelector('[name="lastName"]')  || {}).value || '',
        email:         (form.querySelector('[name="email"]')     || {}).value || '',
        phone:         (form.querySelector('[name="phone"]')     || {}).value || '',
        streetAddress: (form.querySelector('[name="streetAddress"]') || {}).value || '',
        city:          (form.querySelector('[name="city"]')      || {}).value || '',
        state:         (form.querySelector('[name="state"]')     || {}).value || '',
        zip:           (form.querySelector('[name="zip"]')       || {}).value || '',
        ssn:           (form.querySelector('[name="ssn"]')       || {}).value || '',
        dob:           (form.querySelector('[name="dob"]')       || {}).value || '',
        source:        'financing-page',
        timestamp:     new Date().toISOString()
      };

      /* Read API endpoint from the data attribute stamped by Liquid */
      var endpoint = (document.querySelector('.ts-fp') || {}).dataset.endpoint || '';

      if (!endpoint) {
        /* No endpoint configured — show success anyway (dev/staging fallback) */
        console.warn('[TrailerSwap] No API endpoint configured. Set api_endpoint in theme settings.');
        showSuccess();
        return;
      }

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw d; });
          return res.json();
        })
        .then(function () { showSuccess(); })
        .catch(function (err) {
          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
          var msg = (err && err.message) ? err.message : 'Something went wrong. Please try again.';
          if (formErrBox) formErrBox.textContent = msg;
        });
    });
  }

  function showSuccess() {
    if (formView)    formView.style.display = 'none';
    if (successView) successView.style.display = 'flex';
  }

  /* ──────────────────────────────────────────────────────────
     CALCULATOR
  ────────────────────────────────────────────────────────── */
  var unitPriceEl  = document.getElementById('ts-unit-price');
  var downEl       = document.getElementById('ts-down');
  var taxEl        = document.getElementById('ts-tax');
  var tierEl       = document.getElementById('ts-tier');
  var termEl       = document.getElementById('ts-term');
  var feesEl       = document.getElementById('ts-fees');
  var resultEl     = document.getElementById('ts-result');
  var bdLoanEl     = document.getElementById('ts-bd-loan');
  var bdAprEl      = document.getElementById('ts-bd-apr');
  var bdInterestEl = document.getElementById('ts-bd-interest');

  /* Currency-style input formatting on blur/focus */
  function attachCurrencyFormat(input) {
    if (!input) return;
    input.addEventListener('focus', function () {
      /* Strip formatting on focus so user edits raw digits */
      var raw = rawNum(this.value);
      this.value = raw ? String(raw) : '';
    });
    input.addEventListener('blur', function () {
      var raw = rawNum(this.value);
      this.value = raw ? fmtCommas(raw) : '';
    });
  }

  attachCurrencyFormat(unitPriceEl);
  attachCurrencyFormat(downEl);
  attachCurrencyFormat(feesEl);

  /* Tax %: allow decimal, strip non-numeric except one dot */
  if (taxEl) {
    taxEl.addEventListener('blur', function () {
      var raw = parseFloat(this.value) || 0;
      this.value = raw ? raw.toFixed(2) : '';
    });
  }
  /* Term: digits only */
  if (termEl) {
    termEl.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '');
    });
  }

  function calculate() {
    if (!unitPriceEl || !resultEl) return;

    var unitPrice = rawNum(unitPriceEl.value);
    var down      = rawNum(downEl  ? downEl.value  : 0);
    var taxPct    = parseFloat(taxEl ? taxEl.value : 0) || 0;
    var apr       = parseFloat(tierEl ? tierEl.value : 9.9) || 9.9;
    var term      = parseInt(termEl ? termEl.value : 60, 10) || 60;
    var fees      = rawNum(feesEl ? feesEl.value : 0);

    if (!unitPrice || term < 1) {
      resultEl.textContent = '$—';
      if (bdLoanEl)     bdLoanEl.textContent     = '$—';
      if (bdAprEl)      bdAprEl.textContent      = '—%';
      if (bdInterestEl) bdInterestEl.textContent  = '$—';
      return;
    }

    /* Loan = (price × (1 + tax/100)) - down + fees */
    var taxedPrice  = unitPrice * (1 + taxPct / 100);
    var principal   = Math.max(taxedPrice - down + fees, 0);

    /* Monthly payment via amortization formula */
    var r = apr / 12 / 100;
    var monthly;
    if (r === 0) {
      monthly = principal / term;
    } else {
      var factor = Math.pow(1 + r, term);
      monthly = principal * (r * factor) / (factor - 1);
    }

    var totalPaid    = monthly * term;
    var totalInterest = totalPaid - principal;

    /* Update UI */
    resultEl.textContent = fmtCurrencyInt(monthly);
    if (bdLoanEl)     bdLoanEl.textContent     = fmtCurrencyInt(principal);
    if (bdAprEl)      bdAprEl.textContent      = apr.toFixed(1) + '%';
    if (bdInterestEl) bdInterestEl.textContent  = fmtCurrencyInt(totalInterest);
  }

  /* ── AUTO-CALCULATE ─────────────────────────────────────────────────── */
  /* Debounce so we don't recalculate on every keystroke while typing */
  var calcDebounce;
  function scheduleCalc() {
    clearTimeout(calcDebounce);
    calcDebounce = setTimeout(calculate, 350);
  }

  [unitPriceEl, downEl, taxEl, termEl, feesEl].forEach(function (el) {
    if (!el) return;
    el.addEventListener('input', scheduleCalc);
    /* Also allow immediate calculation on Enter key */
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { clearTimeout(calcDebounce); calculate(); }
    });
  });
  if (tierEl) {
    /* Select changes are instant — no debounce needed */
    tierEl.addEventListener('change', calculate);
  }

})();
